import { CommonModule } from '@angular/common';
import { Component, Inject, Optional, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '@app/_services/settings.service';
import { ViewSettingService } from '@app/_services/view-setting.service';
import { InputDropdownComponent } from '@app/components/shared/inputs/input-dropdown/input-dropdown.component';
import { SvgComponent } from '@app/components/shared/svg/svg.component';
import { KebabShowMenuComponent } from '@app/components/shared/kebab-show-menu/kebab-show-menu.component';
import { ShowType } from '@app/_types/generic.type';
import { CustomBottomSheetRef } from '@app/_services/custom-bottom-sheet.service';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-list-view-kebab',
  imports: [InputDropdownComponent, SvgComponent, CommonModule, KebabShowMenuComponent],
  templateUrl: './list-view-kebab.component.html',
  styleUrl: './list-view-kebab.component.scss'
})
export class ListViewKebabComponent {
  // Direct references to the view signals for unified view
  listGroupBy: WritableSignal<string>;
  listShow: WritableSignal<ShowType[]>;
  listGroupedViewType: WritableSignal<string[]>;
  public data: {
    config: {
      name: string;
      groupBy: string;
      groupedViewType: string;
      show: string;
      descriptionType: string;
      hiddenGroupValues: string[];
      hiddenShowValues: ShowType[];
    };
  };
  constructor(
    @Optional() public dialogRef: MatDialogRef<ListViewKebabComponent>,
    public ss: SettingsService,
    public vs: ViewSettingService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: {
      config: {
        name: string;
        groupBy: string;
        groupedViewType: string;
        show: string;
        descriptionType: string;
        hiddenGroupValues: string[];
        hiddenShowValues: ShowType[];
      };
    },

    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: {
      config: {
        name: string;
        groupBy: string;
        groupedViewType: string;
        show: string;
        descriptionType: string;
        hiddenGroupValues: string[];
        hiddenShowValues: ShowType[];
      };
    },

    @Optional() public bottomSheetRef: CustomBottomSheetRef<ListViewKebabComponent>,
  ) {
    this.data = (dialogData || bottomSheetData)!;
    // Use primary settings for unified view
    this.listGroupBy = this.ss.viewSignals()['listGroupBy'];
    this.listShow = this.ss.viewSignals()['listShow'];
    this.listGroupedViewType = this.ss.viewSignals()['listGroupedViewType'];

    dialogRef?.backdropClick().subscribe(async () => {
      this.closeDialog();
    });

    bottomSheetRef?.backdropClick().subscribe(async () => {
      this.closeDialog();
    });
  }

  closeDialog() {
    this.ss.updateView();
    this.close();
  }

  private close(result?: any): void {
    if (this.dialogRef) {
      this.dialogRef.close(result);
    } else if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss(result);
    }
  }
}
